const url = process.env.NODE_ENV === 'development' ? 'http://localhost/zwServer/public/api/' : 'http://zoraworld.online/zwServer/public/api/';

export default url;
